/* arissai-cart-upsell.js v1 — drawer: free-ship bar, upsell, trust row */
(function(){
  'use strict';
  var THRESHOLD = 7500; // cents
  var UPSELLS = ['white-glossy-mug-arissai®', 'embroidered-socks-stylized-eye-design™-by-arissai'];
  var upsellCache = null;

  function money(cents){ return '$' + (cents/100).toFixed(2); }

  function getDrawer(){ return document.querySelector('cart-drawer'); }

  function injectShipBar(drawer, cart){
    var host = drawer.querySelector('.drawer__inner');
    if (!host) return;
    var bar = drawer.querySelector('.ar-shipbar');
    if (!bar){
      bar = document.createElement('div');
      bar.className = 'ar-shipbar';
      bar.setAttribute('data-testid','cart-shipbar');
      host.insertBefore(bar, host.firstChild.nextSibling);
    }
    var total = cart.total_price;
    var left = THRESHOLD - total;
    var pct = Math.min(100, Math.round(total / THRESHOLD * 100));
    bar.innerHTML = (left > 0
      ? '<div class="ar-shipbar__txt">You are <strong>' + money(left) + '</strong> away from <strong>FREE shipping</strong></div>'
      : '<div class="ar-shipbar__txt ar-shipbar__txt--done">🎉 You unlocked <strong>FREE shipping</strong></div>')
      + '<div class="ar-shipbar__track"><div class="ar-shipbar__fill" style="width:' + pct + '%"></div></div>';
  }

  function fetchUpsell(cart, cb){
    if (upsellCache){ cb(upsellCache); return; }
    var inCart = cart.items.map(function(i){ return i.handle; });
    var handle = null;
    for (var k = 0; k < UPSELLS.length; k++){
      if (inCart.indexOf(UPSELLS[k]) === -1){ handle = UPSELLS[k]; break; }
    }
    if (!handle){ cb(null); return; }
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p){ cb(null); return; }
        var v = null;
        for (var i = 0; i < p.variants.length; i++){
          if (p.variants[i].available){ v = p.variants[i]; break; }
        }
        if (!v){ cb(null); return; }
        upsellCache = { title: p.title.split(' | ')[0], img: p.featured_image, price: v.price, variantId: v.id, handle: p.handle };
        cb(upsellCache);
      }).catch(function(){ cb(null); });
  }

  function injectUpsell(drawer, cart){
    if (!cart.item_count) return;
    if (sessionStorage.getItem('arUpsellDismissed')) return;
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer || drawer.querySelector('.ar-upsell')) return;
    fetchUpsell(cart, function(u){
      if (!u || drawer.querySelector('.ar-upsell')) return;
      var inCart = cart.items.some(function(i){ return i.handle === u.handle; });
      if (inCart) return;
      var box = document.createElement('div');
      box.className = 'ar-upsell';
      box.setAttribute('data-testid','cart-upsell');
      box.innerHTML =
        '<button type="button" class="ar-upsell__close" data-testid="cart-upsell-dismiss" aria-label="Dismiss">&times;</button>'+
        '<div class="ar-upsell__label">Complete the look</div>'+
        '<div class="ar-upsell__row">'+
          '<img src="' + u.img + '&width=120" alt="' + u.title + '" width="56" height="56" loading="lazy">'+
          '<div class="ar-upsell__meta"><span class="ar-upsell__title">' + u.title + '</span><span class="ar-upsell__price">' + money(u.price) + '</span></div>'+
          '<button type="button" class="ar-upsell__add" data-testid="cart-upsell-add">Add</button>'+
        '</div>';
      footer.insertBefore(box, footer.firstChild);
      box.querySelector('.ar-upsell__close').addEventListener('click', function(){
        sessionStorage.setItem('arUpsellDismissed','1');
        box.remove();
      });
      box.querySelector('.ar-upsell__add').addEventListener('click', function(){
        var btn = this;
        btn.disabled = true; btn.textContent = '...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ id: u.variantId, quantity: 1 })
        }).then(function(r){ return r.json(); }).then(function(){
          upsellCache = null;
          refreshDrawer();
        }).catch(function(){ btn.disabled = false; btn.textContent = 'Add'; });
      });
    });
  }

  function injectTrust(drawer){
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer || drawer.querySelector('.ar-carttrust')) return;
    var t = document.createElement('div');
    t.className = 'ar-carttrust';
    t.setAttribute('data-testid','cart-trust-row');
    t.innerHTML =
      '<span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 2 4 6v6c0 5 4 9 8 10 4-1 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/></svg>Secure checkout</span>'+
      '<span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 7h13l5 5v5h-2"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>Free US &amp; CA shipping</span>'+
      '<span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 12a9 9 0 0 1 15-6.7l3-2.3v6h-6l2.5-1.9A6.5 6.5 0 1 0 18 14"/></svg>Quality guaranteed</span>';
    footer.appendChild(t);
  }

  function refreshDrawer(){
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r){ return r.json(); })
      .then(function(sections){
        var drawer = getDrawer();
        if (drawer && sections['cart-drawer']){
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh){
            drawer.querySelector('.drawer__inner').replaceWith(fresh.querySelector('.drawer__inner'));
            drawer.classList.remove('is-empty');
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']){
          var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var fresh2 = doc2.getElementById('cart-icon-bubble') || doc2.querySelector('.shopify-section');
          if (fresh2) bubble.innerHTML = fresh2.innerHTML;
        }
        enhance();
      });
  }

  var pending = null;
  function enhance(){
    var drawer = getDrawer();
    if (!drawer) return;
    if (pending) clearTimeout(pending);
    pending = setTimeout(function(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        if (!cart.item_count) return;
        injectShipBar(drawer, cart);
        injectUpsell(drawer, cart);
        injectTrust(drawer);
      });
    }, 120);
  }

  function init(){
    var drawer = getDrawer();
    if (!drawer) return;
    var mo = new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++){
        var m = muts[i];
        if (m.type === 'attributes' && drawer.classList.contains('active')){ enhance(); return; }
        if (m.type === 'childList'){ enhance(); return; }
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  var css = document.createElement('style');
  css.textContent =
    '.ar-shipbar{padding:1.2rem 1.5rem;background:#faf7ef;border-bottom:1px solid #eee}'+
    '.ar-shipbar__txt{font-size:1.25rem;color:#333;margin-bottom:.7rem}'+
    '.ar-shipbar__txt--done{color:#1a7a3c}'+
    '.ar-shipbar__track{height:6px;background:#e8e4d8;border-radius:99px;overflow:hidden}'+
    '.ar-shipbar__fill{height:100%;background:linear-gradient(90deg,#d4af37,#b08d1e);border-radius:99px;transition:width .5s ease}'+
    '.ar-upsell{position:relative;border:1px solid #eee;border-radius:12px;padding:1.1rem 1.2rem;margin-bottom:1.4rem;background:#fafafa}'+
    '.ar-upsell__close{position:absolute;top:.4rem;right:.7rem;background:none;border:none;font-size:1.8rem;line-height:1;color:#999;cursor:pointer;padding:.2rem .4rem}'+
    '.ar-upsell__close:hover{color:#111}'+
    '.ar-upsell__label{font-size:1.05rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#b08d1e;margin-bottom:.8rem}'+
    '.ar-upsell__row{display:flex;align-items:center;gap:1.1rem}'+
    '.ar-upsell__row img{border-radius:8px;object-fit:cover;flex-shrink:0}'+
    '.ar-upsell__meta{display:flex;flex-direction:column;gap:.2rem;flex:1;min-width:0}'+
    '.ar-upsell__title{font-size:1.25rem;font-weight:600;color:#222;line-height:1.3}'+
    '.ar-upsell__price{font-size:1.2rem;color:#666}'+
    '.ar-upsell__add{background:#0f0f15;color:#fff;border:none;border-radius:99px;font-size:1.2rem;font-weight:700;padding:.8rem 1.8rem;cursor:pointer;transition:background .2s}'+
    '.ar-upsell__add:hover{background:#d4af37;color:#0f0f15}'+
    '.ar-carttrust{display:flex;justify-content:center;gap:1.6rem;flex-wrap:wrap;padding-top:1.2rem;margin-top:.4rem;border-top:1px solid #eee}'+
    '.ar-carttrust span{display:inline-flex;align-items:center;gap:.5rem;font-size:1.05rem;color:#666}';
  document.head.appendChild(css);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Sticky mobile ATC — the CSS for .arissai-sticky-atc already ships in arissai-custom.css */
(function(){
  'use strict';
  if (location.pathname.indexOf('/products/') !== 0) return;

  function build(){
    if (document.querySelector('.arissai-sticky-atc')) return;
    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1');
    var getPrice = function(){
      var el = document.querySelector('.product__info-container .price-item--sale.price-item--last') ||
               document.querySelector('.product__info-container .price__regular .price-item--regular') ||
               document.querySelector('.product__info-container .price-item');
      return el ? el.textContent.trim() : '';
    };
    var bar = document.createElement('div');
    bar.className = 'arissai-sticky-atc';
    bar.setAttribute('data-testid','sticky-atc-bar');
    bar.style.cssText = 'display:none;';
    bar.innerHTML =
      '<div class="arissai-sticky-atc__info">'+
        '<span class="arissai-sticky-atc__name">' + (titleEl ? titleEl.textContent.trim() : 'This piece') + '</span>'+
        '<span class="arissai-sticky-atc__price">' + getPrice() + '</span>'+
      '</div>'+
      '<button type="button" class="arissai-sticky-atc__btn" data-testid="sticky-atc-add">Add to cart</button>';
    document.body.appendChild(bar);

    document.addEventListener('change', function(){
      setTimeout(function(){
        var p = bar.querySelector('.arissai-sticky-atc__price');
        if (p) p.textContent = getPrice();
      }, 250);
    });

    bar.querySelector('.arissai-sticky-atc__btn').addEventListener('click', function(){
      var real = form.querySelector('button[name="add"]');
      if (real && real.hasAttribute('disabled')) return;
      var b = this;
      if (b.disabled) return;
      var orig = b.textContent;
      b.disabled = true;
      b.textContent = 'Adding\u2026';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
      var poll = setInterval(function(){
        var d = document.querySelector('cart-drawer');
        if (d && d.classList.contains('active')){
          clearInterval(poll);
          b.textContent = 'Added \u2713';
          setTimeout(function(){ b.disabled = false; b.textContent = orig; }, 1500);
        }
      }, 150);
      setTimeout(function(){ clearInterval(poll); b.disabled = false; b.textContent = orig; }, 8000);
    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();

/* Instant prefetch: product/collection pages preload on hover or first touch */
(function(){
  'use strict';
  var seen = {};
  function pf(href){
    if (seen[href]) return; seen[href] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }
  function onHint(e){
    var a = e.target && e.target.closest && e.target.closest('a[href^="/"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (!h) return;
    if (h.indexOf('/products/') === 0 || h.indexOf('/collections/') === 0) pf(h.split('#')[0]);
  }
  document.addEventListener('mouseover', onHint, { passive: true, capture: true });
  document.addEventListener('touchstart', onHint, { passive: true, capture: true });
})();
